<template>
  <div>
    <v-card class="px-2" style="border: 1px solid #eee; border-radius: 4px;" elevation="0">
      <v-layout align-center justify-space-between style="min-height: 40px">
        <div>{{ $t('whatsapp_custom_wording') }}</div>
        <v-btn icon small color="primary" @click="handleAddCustomWording" v-if="!isLiveChat">
          <em class="fas fa-plus"></em>
        </v-btn>
      </v-layout>
      <v-divider></v-divider>
      <div class="pt-2">
        <template v-if="Object.keys(customWording).length > 0">
          <v-layout v-for="(_, key, index) in customWording" :key="index">
            <v-flex style="display: flex" v-if="isLiveChat" class="pt-2">
              {{ index + 1 }} :
            </v-flex>
            <v-flex class="form-control">
              <input type="text" placeholder="Enter wording" v-model="customWording[key]" />
            </v-flex>
            <v-flex style="display: flex" justify-end v-if="!isLiveChat">
              <v-btn flat color="error" icon @click="handleDeleteCustomWording(key)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <div v-else class="text-xs-center pb-1">
          <v-btn small flat color="primary" @click="handleAddCustomWording">
            <em class="fas fa-plus mr-2"></em>
            {{ $t('whatsapp_add_custom_wording') }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    isLiveChat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customWording: {}
    }
  },
  mounted() {
    this.customWording = this.value
  },
  watch: {
    value: {
      handler() {
        this.customWording = this.value
      },
      deep: true
    },
    customWording: {
      handler() {
        this.$emit('input', this.customWording)
      },
      deep: true
    }
  },
  methods: {
    handleAddCustomWording() {
      const tempCustomWording = cloneDeep(this.customWording) || {}
      const countCustomWording = Object.keys(tempCustomWording).length

      Object.assign(tempCustomWording, {
        ...tempCustomWording,
        [`custom_wording_${countCustomWording + 1}`]: ''
      })
      this.customWording = tempCustomWording
    },
    handleDeleteCustomWording(key) {
      try {
        const tempCustomWording = cloneDeep(this.customWording)
        const { [key]: unused, ...rest } = tempCustomWording

        const tempCurrent = { ...rest }
        const currentCustomWording = {}

        Object.keys(tempCurrent).forEach((key, index) => {
          Object.assign(currentCustomWording, { [`custom_wording_${index + 1}`]: tempCurrent[key] })
        })
        this.customWording = currentCustomWording
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/CustomWordingManageCard.vue